import {Howl} from 'howler'
import handleAudioLoadError from '../utils/handleAudioLoadError'
import handleAudioPlayError from '../utils/handleAudioPlayError'

const howl = new Howl({
  src: ['/sounds/toggle-off.webm', '/sounds/toggle-off.mp3'],
  preload: true,
  onloaderror: handleAudioLoadError,
  onplayerror: handleAudioPlayError,
})

export default howl
